<template >
  <transition mode="out-in">
    <div v-if="!mobile" class="screen" :class="[$route.params.name]">
      <navs :nav="nav" @index-page="indexPage"></navs>
      <div class="screen__wrapper">
        <div class="screen-digital screen__item screen__1">
          <div class="screen-digital__inner">
            <div :style="scale" class="screen-digital__frontstage screen-digital__frontstage_left">
              <div class="screen-digital__pic screen-digital__pic-1"></div>
              <div class="screen-digital__pic screen-digital__pic-2"></div>
              <div class="screen-digital__pic screen-digital__pic-3"></div>
            </div>
            <div
              :style="scale"
              class="screen-digital__frontstage screen-digital__frontstage_center"
            >
              <div class="screen-digital__pic screen-digital__pic-4"></div>
              <div class="screen-digital__pic screen-digital__pic-5"></div>
              <div class="screen-digital__pic screen-digital__pic-6"></div>
            </div>
            <div :style="scale" class="screen-digital__content">
              <div class="screen-digital__controls">
                <div
                  class="screen-digital__desc"
                >Полный спектр Digital услуг: стратегия и&nbsp;креатив, разработка и&nbsp;ведение SMM и&nbsp;media-кампаний, собственное производство мобильных приложений и&nbsp;проектов любой сложности силами внутреннего production-отдела</div>
                <div class="screen-digital__buttons">
                  <a
                    @click="gaClickDititalPortfolio"
                    target="_blank"
                    href="https://whynotdigital.ru/"
                    class="button button-digital"
                  >
                    <i></i>
                    <span>смотреть Портфолио</span>
                  </a>
                  <!-- <a
                    @click="gaClickDititalSite"
                    target="_blank"
                    href="http://w-not.ru/"
                    class="button button-digital-light"
                  >
                    <i></i>
                    <span>перейти на сайт</span>
                  </a> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="screen-video screen__item screen__2">
          <div class="screen-video__border"></div>
          <div class="screen-video__inner">
            <div :style="scale" class="screen-video__frontstage screen-video__frontstage_left">
              <div class="screen-video__pic screen-video__pic-1"></div>
            </div>
            <div :style="scale" class="screen-video__frontstage screen-video__frontstage_center">
              <div class="screen-video__pic screen-video__pic-3"></div>
              <div class="screen-video__pic screen-video__pic-4"></div>
            </div>
            <div :style="scale" class="screen-video__content">
              <div class="screen-video__controls">
                <div class="screen-video__pic screen-video__pic-2"></div>
                <div
                  class="screen-video__desc"
                >Создание видеороликов от&nbsp;разработки синопсиса и&nbsp;раскадровки, до&nbsp;организации и&nbsp;полного контроля съемок с&nbsp;использованием лучшего мирового оборудования и&nbsp;привлечением всемирно известных имен</div>
                <div class="screen-video__buttons">
                  <a
                    @click="gaClickVideoPortfolio"
                    target="_blank"
                    href="https://vimeo.com/whynotpro/videos"
                    class="button button-video"
                  >
                    <i></i>
                    <span>смотреть работы</span>
                  </a>
                  <!-- <a
                    @click="gaClickVideoSite"
                    target="_blank"
                    href="http://w-not.pro/"
                    class="button"
                  >
                    <i></i>
                    <span>перейти на сайт</span>
                  </a> -->
                  <!-- <a
                    @click="gaClickVideoVimeo"
                    target="_blank"
                    href="https://vimeo.com/whynotpro/videos"
                    class="button button-vimeo"
                  >
                    <i></i>
                    <span></span>
                  </a> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="screen-events screen__item screen__3">
          <div class="screen-events__inner">
            <div
              :style="scale"
              class="screen-events__frontstage screen-events__frontstage_top-left"
            >
              <div class="screen-events__pic screen-events__pic-1"></div>
            </div>
            <div
              :style="scale"
              class="screen-events__frontstage screen-events__frontstage_top-right"
            >
              <div class="screen-events__pic screen-events__pic-2"></div>
            </div>
            <div
              :style="scale"
              class="screen-events__frontstage screen-events__frontstage_bottom-left"
            >
              <div class="screen-events__pic screen-events__pic-3"></div>
              <div class="screen-events__pic screen-events__pic-4"></div>
            </div>
            <div
              :style="scale"
              class="screen-events__frontstage screen-events__frontstage_bottom-right"
            >
              <div class="screen-events__pic screen-events__pic-5"></div>
            </div>
            <div :style="scale" class="screen-events__frontstage screen-events__frontstage_left">
              <div class="screen-events__pic screen-events__pic-6"></div>
              <div class="screen-events__pic screen-events__pic-7"></div>
            </div>
            <div :style="scale" class="screen-events__frontstage screen-events__frontstage_center">
              <div class="screen-events__pic screen-events__pic-8"></div>
            </div>
            <div :style="scale" class="screen-events__content">
              <div class="screen-events__controls">
                <div
                  class="screen-events__desc"
                >Разработка и&nbsp;реализация BTL и&nbsp;Promo-кампаний, проведение Event любой сложности и&nbsp;направленности</div>
                <div class="screen-events__buttons">
                  <a
                    @click="$modal.show('video'); gaClickBtlPortfolio;"
                    class="button button-events"
                  >
                    <i></i>
                    <span>смотреть кейс</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Navs from "./nav";
import getScale from "./zoom";
import isMobile from "@/components/isMobile";

export default {
  data() {
    return {
      scale: {
        transform: `scale(${getScale()})`
      },
      nav: [
        {
          name: "DIGITAL",
          link: "/detail/digital",
          isActive: false,
          width: 0
        },
        {
          name: "VIDEO PROD",
          link: "/detail/video",
          isActive: false,
          width: 0
        },
        {
          name: "BTL&EVENTS",
          link: "/detail/events",
          isActive: false,
          width: 0
        }
      ],
      index: null,
      mobile: false
    };
  },
  components: {
    Navs
  },
  watch: {},
  created() {
    if (isMobile()) {
      this.mobile = true;
    }
  },
  mounted() {
    if (this.$route.hash === "#video") {
      this.$modal.show("video");
      this.gaClickShowVideo1();
    }

    window.addEventListener("resize", () => {
      this.scale.transform = `scale(${getScale()})`;
    });
  },
  methods: {
    indexPage: function(index) {
      this.index = index;
    },
    gaClickDititalPortfolio() {
      this.$gtm.trackEvent({
        event: "event",
        event_category: "wng_digital",
        event_action: "click",
        event_label: "portfolio"
      });
    },
    gaClickDititalSite() {
      this.$gtm.trackEvent({
        event: "event",
        event_category: "wng_digital",
        event_action: "click",
        event_label: "site"
      });
    },
    gaClickVideoPortfolio() {
      this.$gtm.trackEvent({
        event: "event",
        event_category: "wng_video",
        event_action: "click",
        event_label: "portfolio"
      });
    },
    gaClickVideoSite() {
      this.$gtm.trackEvent({
        event: "event",
        event_category: "wng_video",
        event_action: "click",
        event_label: "site"
      });
    },
    gaClickVideoVimeo() {
      this.$gtm.trackEvent({
        event: "event",
        event_category: "wng_video",
        event_action: "click",
        event_label: "vimeo"
      });
    },
    gaClickBtlPortfolio() {
      this.$gtm.trackEvent({
        event: "event",
        event_category: "wng_btl",
        event_action: "click",
        event_label: "portfolio"
      });
    },
    gaClickShowVideo1() {
      this.$gtm.trackEvent({
        event: "event",
        event_category: "wng_btl",
        event_action: "show",
        event_label: "video1"
      });
    }
  }
};
</script>

<!-- <style>
  @import '../styles/inner.css';
</style> -->

<style src="@/styles/inner.css"></style>



// WEBPACK FOOTER //
// src/components/Detail.vue